import ToolbarButton from "@/components/ToolbarButton";
import { Loader2, Save } from "lucide-react";
import { useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface SaveButtonProps {
  className?: string;
  labelClassName?: string;
}

export default function SaveButton({
  className,
  labelClassName,
}: SaveButtonProps) {
  const { t } = useTranslation();
  const { isSubmitting, disabled } = useFormState();

  return (
    <ToolbarButton
      type="submit"
      className={className}
      disabled={isSubmitting || disabled}
    >
      {isSubmitting ? (
        <Loader2 className="mr-2 h-5 w-5 animate-spin" />
      ) : (
        <Save className="mr-2 h-5 w-5" />
      )}
      <span className={labelClassName}>
        {isSubmitting
          ? t("commonEditor.toolbar.saving")
          : t("commonEditor.toolbar.save")}
      </span>
    </ToolbarButton>
  );
}
